import { ChakraProvider as ThemeProvider, extendTheme } from '@chakra-ui/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { customTheme } from '@/theme/index';
import { IntegrationRoutes } from './Route';
import '../styles/index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 0, refetchOnWindowFocus: false } },
});

export const IntegrationApp = () => {
  const theme = extendTheme({ ...customTheme });

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <IntegrationRoutes />
        </QueryClientProvider>
      </ThemeProvider>
    </Router>
  );
};
